import * as actionTypes from '../types/stock';

export function fetchStock(payload) {
  return {
    type: actionTypes.FETCH_STOCK,
    payload
  };
}

export function fetchStockSuccess(payload) {
  return {
    type: actionTypes.FETCH_STOCK_SUCCESS,
    payload
  };
}

export function fetchStockFail(payload) {
  return {
    type: actionTypes.FETCH_STOCK_FAIL,
    payload
  };
}

export function fetchStockOptions(payload) {
  return {
    type: actionTypes.FETCH_STOCK_OPTIONS,
    payload
  };
}

export function fetchStockOptionsSuccess(payload) {
  return {
    type: actionTypes.FETCH_STOCK_OPTIONS_SUCCESS,
    payload
  };
}

export function fetchStockOptionsFail(payload) {
  return {
    type: actionTypes.FETCH_STOCK_OPTIONS_FAIL,
    payload
  };
}

export function selectPlantId(payload) {
  return {
    type: actionTypes.SELECT_PLANT_ID,
    payload
  };
}

export function getSettingsPlantStorageTime(payload) {
  return {
    type: actionTypes.GET_SETTINGS_PLANT_STORAGE_TIME,
    payload
  };
}
export function getSettingsPlantStorageTimeSuccess(payload) {
  return {
    type: actionTypes.GET_SETTINGS_PLANT_STORAGE_TIME_SUCCESS,
    payload
  };
}
export function getSettingsPlantStorageTimeFail(payload) {
  return {
    type: actionTypes.GET_SETTINGS_PLANT_STORAGE_TIME_FAIL,
    payload
  };
}

export function setSettingsPlantStorageTime(payload) {
  return {
    type: actionTypes.SET_SETTINGS_PLANT_STORAGE_TIME,
    payload
  };
}
export function setSettingsPlantStorageTimeSuccess(payload) {
  return {
    type: actionTypes.SET_SETTINGS_PLANT_STORAGE_TIME_SUCCESS,
    payload
  };
}
export function setSettingsPlantStorageTimeFail(payload) {
  return {
    type: actionTypes.SET_SETTINGS_PLANT_STORAGE_TIME_FAIL,
    payload
  };
}

export function sendFileStockSettings(payload) {
  return {
    type: actionTypes.SEND_FILE_STOCK_SETTINGS,
    payload
  };
}
export function sendFileStockSettingsSuccess(payload) {
  return {
    type: actionTypes.SEND_FILE_STOCK_SETTINGS_SUCCESS,
    payload
  };
}
export function sendFileStockSettingsFail(payload) {
  return {
    type: actionTypes.SEND_FILE_STOCK_SETTINGS_FAIL,
    payload
  };
}

export function statusFileStockSettings(payload) {
  return {
    type: actionTypes.STATUS_FILE_STOCK_SETTINGS,
    payload
  };
}
export function statusFileStockSettingsSuccess(payload) {
  return {
    type: actionTypes.STATUS_FILE_STOCK_SETTINGS_SUCCESS,
    payload
  };
}
export function statusFileStockSettingsFail(payload) {
  return {
    type: actionTypes.STATUS_FILE_STOCK_SETTINGS_FAIL,
    payload
  };
}
